
import Vue from 'vue';
import RunnitVideo from '@/views/Runnits/RunnitVideo.vue';

export default Vue.extend({
	name: 'RunnitSelectedVideo',
	props: {
		nodeRunResult: { type: Object, default: null },
		upload: { type: Object, default: null },
		coveredByMask: { type: Boolean, default: false },
		hideClearButton: { type: Boolean, default: false },
	},
	components: {
		RunnitVideo,
	},
});
